import React from "react";
import { IMFADevice } from "api/entities/mfa";
import MoreOptions from "components/shared-ui/more-options";

export interface IMFADeviceMoreOptionsProps {
  device: IMFADevice;
  onDelete: (deviceId: string) => void;
  onRefreshCodes: (deviceId: string) => void;
}

export const MFADeviceMoreOptions = (props: IMFADeviceMoreOptionsProps) => {
  const getOptions = () => {
    return [
      {
        label: "Refresh Recovery Codes",
        onClick: () => props.onRefreshCodes(props.device.id),
      },
      {
        label: "Delete",
        onClick: () => props.onDelete(props.device.id),
      },
    ];
  };

  return <MoreOptions options={getOptions()} />;
};
